// kind matches tireAvailability.js: "local" | "preorder" | "eu" | "ondemand" | "out"
const EU_TOOLTIP =
  "צמיג זה מגיע ממלאי הסחר האירופאי שלנו. ניתן להזמינו עם מקדמה והוא יגיע עם המשלוח הבא לישראל. מועד ההגעה המשוער הוא הערכה בלבד.";
const ONDEMAND_TOOLTIP =
  "הצמיג שאתה רואה הוא הזמנה מוקדמת. הצמיג יוזמן במשלוח הבא ואינו נמצא במלאי כרגע. מועד ההספקה המשוער הוא רק הערכה ויכול להתארך בעקבות בעיות לוגיסטיות וגורמים נוספים.";

function details(partial) {
  return {
    kind: partial.kind,
    label: partial.label,
    lines: partial.lines || [],
    arrivalLabel: partial.arrivalLabel == null ? null : partial.arrivalLabel,
    tooltip: partial.tooltip == null ? null : partial.tooltip,
  };
}

function isOutOfStock(product) {
  const visibility = product && product.visibility;
  return visibility === "outofstock" || visibility === "notinstock";
}

export function getTireAvailabilityDetails(product, ctx = {}) {
  const item = product || {};
  const context = ctx || {};

  if (isOutOfStock(item)) {
    return details({ kind: "out", label: "לא במלאי" });
  }

  if (item.source === "georgia") {
    const cm = context.euContainerMode;
    const containerActive = !!(cm && cm.enabled);
    const lines = [
      (containerActive && cm.statusText) || "זמין להזמנה מהמלאי האירופאי שלנו",
    ];

    if (containerActive && cm.tiresOrderedText) {
      lines.push(cm.tiresOrderedText);
    }
    if (context.nextShipment) {
      lines.push(`תאריך הגעה משוער: ${context.nextShipment}`);
    }

    return details({
      kind: "eu",
      label: "מלאי אירופה",
      lines,
      arrivalLabel: (containerActive && cm.arrivalChipText) || "הגעה תוך 2-3 חודשים",
      tooltip: EU_TOOLTIP,
    });
  }

  if (item.visibility === "instock") {
    return details({ kind: "local", label: "במלאי מיידי" });
  }

  if (item.visibility === "preorder") {
    return details({
      kind: "preorder",
      label: "מגיע במשלוח הקרוב",
      lines: context.currentShipment ? [`צפי הגעה: ${context.currentShipment}`] : [],
    });
  }

  if (item.visibility === "ondemand") {
    return details({
      kind: "ondemand",
      label: "הזמנה מראש",
      lines: ["במידה ויוזמן - צפי הגעה למחסנים בארץ", context.nextShipment].filter(Boolean),
      tooltip: ONDEMAND_TOOLTIP,
    });
  }

  return details({ kind: "out", label: "לא במלאי" });
}
